import { createRouterReducer } from '@lagunovsky/redux-react-router';
import { combineReducers } from 'redux';

import history from '../history';
import BGMReducers from './BGMReducers';
import DepositLinkReducers from './cashflow/depositLink';
import DetailPageReducers from './DetailPage';
import AllGameReducers from './game/allGame';
import FavoriteGameListReducers from './game/favoriteGameList';
import FullScreenReducers from './game/fullScreen';
import GameAccessToolReducers from './game/gameAccessTool';
import GameConfigReducers from './game/gameConfig';
import GameLinkReducers from './game/gameLink';
import GameListReducers from './game/gameList';
import GameOnlinePlayerReducers from './game/gameOnlinePlayer';
import GameVipBarReducers from './game/gameVipBar';
import OpenGameReducers from './game/openGame';
import triggerGameReducers from './game/triggerGameLink';
import gameLoadingReducers from './game/triggerGameLoading';
import TriggerGameBoxTransferReducers from './game/triggerTransfer';
import LoadingStatusReducers from './loading/LoadingStatus';
import LoadingReducers from './LoadingReducers';
import announcementListReducers from './member/announcementList';
import BonusReducers from './member/bonusReducers';
import CarouselListReducers from './member/carouselList';
import openClearCacheReducers from './member/clearCache';
import openClearCashReducers from './member/clearCash';
import colorModeReducers from './member/colorModeOpen';
import comissionListPopReducers from './member/comissionListPop';
import cryptoReducers from './member/cryptoRate';
import CurrencyReducers from './member/currency';
import CurrencyExchangeReducers from './member/currencyExchange';
import detectInvalidAuthReducers from './member/detectInvalidAuth';
import DisplayCryptoInFiatReducers from './member/displayCryptoInFiat';
import eventListReducers from './member/eventList';
import GameBoxStatusReducers from './member/gameboxStatus';
import GameCurrencyReducers from './member/gameCurrency';
import gameMarqueeListReducers from './member/gameMarqueeList';
import HideZeroAmountReducers from './member/hideZeroAmount';
import inboxListReducers from './member/inboxList';
import languagePopReducers from './member/languagePop';
import LossPointStateReducers from './member/lossPointStateReducers';
import maintainAlertReducers from './member/maintainAlertReducers';
import marqueeListReducers from './member/marqueeList';
import MemberInfoReducers from './member/memberInfo';
import openChatRoomReducers from './member/openChat';
import openFreezeModalReducers from './member/openFreezeModal';
import gameDescriptionPopReducers from './member/openGameDescription';
import ReferDetailReducers from './member/referDetail';
import StoreFileReducers from './member/storeFile';
import StoreInboxReducers from './member/storeInboxDetail';
import mainThemeReducers from './member/theme';
import TransferInGameStateReducer from './member/transferInGameState';
import StoreTransferWalletReducers from './member/transferWallet';
import TriggerTransferGivenUpPointReducers from './member/triggerTransferGivenUpPointReducers';
import storeVipDetailReducers from './member/vipDetail';
import WagerConfigReducers from './member/wagerConfig';
import WalletCurrencyReducers from './member/walletCurrency';
import walletSettingPopReducers from './member/walletSettingPop';
import MenuSelectReducers from './MenuStatus';
import MenuStickyLeftReducers from './menuStickyLeft';
import NoticeReducers from './NoticeReducers';
import MenuReducers from './OpenMenu';
import SocketMessageReducers from './SocketMessage';
import SubMenuReducers from './SubMenuController';
import TriggerReducers from './trigger';

const AllReducers = combineReducers({
  isLoading: LoadingReducers,
  isNotice: NoticeReducers,
  isDetailPage: DetailPageReducers,
  isMenuOpen: MenuReducers,
  isMenuSelect: MenuSelectReducers,
  isMemberInfo: MemberInfoReducers,
  isCurrencyExchange: CurrencyExchangeReducers,
  isGameList: GameListReducers,
  isGameLink: GameLinkReducers,
  isLoaderStatus: LoadingStatusReducers,
  isDepositLink: DepositLinkReducers,
  isGameOpen: OpenGameReducers,
  isCryptoRatio: cryptoReducers,
  isReferDetail: ReferDetailReducers,
  isOpenFullScreen: FullScreenReducers,
  isHandleAllGame: AllGameReducers,
  isLanguagePop: languagePopReducers,
  isWalletSettingPop: walletSettingPopReducers,
  isComissionListPop: comissionListPopReducers,
  isVipBar: GameVipBarReducers,
  isAccessTool: GameAccessToolReducers,
  isUploadImages: StoreFileReducers,
  isGameConfig: GameConfigReducers,
  isTransferWallet: StoreTransferWalletReducers,
  isTheme: mainThemeReducers,
  isFavoriteGameList: FavoriteGameListReducers,
  isVipDetail: storeVipDetailReducers,
  isStickyLeft: MenuStickyLeftReducers,
  isGameDescriptionPop: gameDescriptionPopReducers,
  isInboxDetail: StoreInboxReducers,
  isOpenChatRoom: openChatRoomReducers,
  isTriggerTransferTab: TriggerGameBoxTransferReducers,
  isGlobalTrigger: TriggerReducers,
  isMarqueeList: marqueeListReducers,
  isGameMarqueeList: gameMarqueeListReducers,
  isAnnouncementList: announcementListReducers,
  isCachePop: openClearCacheReducers,
  isClearCashPop: openClearCashReducers,
  isTriggerGameLink: triggerGameReducers,
  isInboxList: inboxListReducers,
  isGameLoading: gameLoadingReducers,
  isNowCurrency: CurrencyReducers, //目前以法幣顯示的幣別
  isWalletCurrency: WalletCurrencyReducers, //目前右上錢包幣別
  isHideZeroAmount: HideZeroAmountReducers, //隱藏零數金額
  isDisplayCryptoInFiat: DisplayCryptoInFiatReducers, //顯示加密貨幣轉換法幣
  isEventList: eventListReducers, //活動列表
  isGameCurrency: GameCurrencyReducers, //遊戲內頁幣別
  isSubMenuControl: SubMenuReducers,
  isColorMode: colorModeReducers,
  isBonus: BonusReducers,
  isWagerConfig: WagerConfigReducers,
  isCallbackInvalid: detectInvalidAuthReducers,
  isCarouselList: CarouselListReducers,
  isGameBoxStatus: GameBoxStatusReducers,
  isGameOnlinePlayer: GameOnlinePlayerReducers,
  isOpenFreezeModal: openFreezeModalReducers,
  navigator: createRouterReducer(history),
  router: createRouterReducer(history),
  isBGMEnabled: BGMReducers, //背景音樂控制
  isLossPointState: LossPointStateReducers, //輸分不可充值提示視窗判斷值
  isTriggerGivenUpPoint: TriggerTransferGivenUpPointReducers, //觸發棄分轉點的頁面、配合ws使用
  isSocketMessage: SocketMessageReducers, //socket訊息
  isMaintainAlert: maintainAlertReducers, //維護通知判斷
  isTransferInGameState: TransferInGameStateReducer
});

export default AllReducers;
